import React from "react";
import ComingSoon from './components/ComingSoon';
import MadeInGermanyExcellenceSection from './components/MadeInGermanyExcellenceSection';
import { HelmetProvider } from "react-helmet-async";
// Define props interface for ContactForm
interface ContactFormProps {
  language?: string; // Optional language prop with default 'en'
}

const ContactForm: React.FC<ContactFormProps> = ({ language = 'en' }) => {
  return (
    <div className="min-h-screen bg-white">
      <main>
        <HelmetProvider>
        <ComingSoon language={language} />
       
        <MadeInGermanyExcellenceSection language={language} />
        </HelmetProvider>
      </main>
    </div>
  );
};

export default ContactForm;